<template>
  <el-dialog :visible.sync="feedBackDialogVisible" :before-close="close" title="企业面试反馈"
             width="400px">
    <el-form :inline="true" :model="form">
      <el-form-item label="请选择面试反馈结果">
        <el-select v-model="form.feedbackStatus" placeholder="请选择面试反馈结果" clearable>
          <el-option label="意向录用" value="1" />
          <el-option label="暂不录用" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="自定义面试反馈内容">
        <el-input v-model="form.content" type="textarea" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="buttons">
      <el-button @click="close">取 消</el-button>
      <el-button :loading="feedBackLoading" :class="{ disableBtn: !form['feedbackStatus'] }"
                 :disabled="!form['feedbackStatus']" type="primary" class="blue-bg"
                 @click="toFeedBack">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    parentFeedBackDialogVisible: {
      type: Boolean,
      default() {
        return false
      }
    },
    id: {
      type: String || Number,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      feedBackDialogVisible: false,
      form: {
        feedbackStatus: '',
        content: ''
      },
      feedBackLoading: false
    }
  },
  watch: {
    parentFeedBackDialogVisible(v) {
      this.feedBackDialogVisible = v
    }
  },
  created() {
    this.feedBackDialogVisible = this.parentFeedBackDialogVisible
  },
  methods: {
    close(isSucess) {
      this.feedBackDialogVisible = false
      this.$emit('close', isSucess)
    },
    toFeedBack() {
      this.feedBackLoading = true
      this.$api.enterpriseFeedBack(
        {
          id: this.id,
          enterpriseFeedbackStatus: this.form['feedbackStatus'],
          content: this.form['content']
        },
        () => {
          this.close(1)
          this.feedBackLoading = false
          this.$message.success('企业面试结果反馈成功！')
        }
      )
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/css/buttons.scss";

.buttons {
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise/browseResume/detail/feedbackDialog.vue